<template>
    <!-- <div>
        <div class="container-header-main">
            <div class="wrapper-header-main">
                <div class="wrapper-header-back">
                    <div @click="clickBack" class="btn-back">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M10.6 12.71a1 1 0 0 1 0-1.42l4.59-4.58a1.001 1.001 0 1 0-1.41-1.42L9.19 9.88a3 3 0 0 0 0 4.24l4.59 4.59a1 1 0 0 0 1.41-1.42l-4.59-4.58z"
                                fill="#fff"
                            />
                        </svg>
                    </div>
                </div>
                <div class="wrapper-header-text">
                    <span>{{ titleName }}</span>
                </div>
            </div>
        </div>
    </div> -->
    <div class="header-page header-other">
        <a class="btn-back" @click="clickBack">
            <img src="@/assets/icon-back.svg" />
        </a>
        <span>{{ titleName }}</span>
    </div>
</template>

<script>
import CheckLogin from "@/mixin/CheckLogin.js";

//plugin
export default {
    name: "Header-main",
    components: {},
    mixins: [CheckLogin],
    props: {
        setTitle: String,
        setHref: String,
        showLogo: Boolean
    },
    data: function() {
        return {
            titleName: this.setTitle,
            hrefName: this.setHref,
            getLogo: this.showLogo
        };
    },
    created: function() {},
    methods: {
        clickBack() {
            this.$router.push(`/${this.hrefName}`);
        }
    }
};
</script>

<style lang="scss">
.container-header-main {
    z-index: 2;
    width: 100%;
    .wrapper-header-main {
        text-align: center;
        display: flex;
        padding: 15px 10px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        background-color: #f6ffef00;
        position: relative;
        .wrapper-header-back {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            z-index: 9;
        }
        .wrapper-header-text {
            width: 100%;
            // position: relative;
            padding: 0 10px;
        }
        .wrapper-header-text span {
            // text-align: center;
            width: 100%;
            max-width: 220px;
            position: absolute;
            top: 50%;
            left: 50%;
            margin: 0;
            line-height: 1.05;
            font-size: 18px;
            transform: translate(-50%, -50%);
            color: white;
            font-family: "PromptRegular";
        }
        .wrapper-header-logo {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            height: 36px;
            .bg-logo img {
                width: 70px;
                height: 36px;
            }
        }
    }
}
.header-other {
    font-size: 18px;
    line-height: 1.4;
}
</style>
